export const cardFormColsProps = {
  cols: '12',
  lg: '4',
  'offset-lg': '4',
}
